
import { useToast } from "@/components/ui/use-toast";
import { WordPair } from "@/types/game";

/**
 * Validates if a word can be submitted
 */
export const validateWordSubmission = (
  currentWord: string,
  usedWords: Set<string>,
  gameId: string | null,
  isSubmitting: boolean,
  gameOver: boolean
): { isValid: boolean; normalizedWord: string; errorMessage?: string } => {
  // CRITICAL FIX: Don't check isSubmitting here - only check if word is valid and game isn't over
  if (!currentWord.trim() || !gameId || gameOver) {
    return { 
      isValid: false, 
      normalizedWord: '' 
    };
  }
  
  // Trim the word before checking if it's already used or submitting
  const trimmedWord = currentWord.trim();
  const normalizedWord = trimmedWord.toLowerCase();
  
  if (usedWords.has(normalizedWord)) {
    return { 
      isValid: false,
      normalizedWord,
      errorMessage: "already used"
    };
  }
  
  return { 
    isValid: true, 
    normalizedWord 
  };
};
